export const REQUEST = "/api/drivers/drivers/-REQUEST";
export const SUCCESS = "/api/drivers/drivers/-SUCCESS";
export const FAILURE = "/api/drivers/drivers/-FAILURE";


// WEBPACK FOOTER //
// ./src/ducks/drivers/constants.js